import styled from 'styled-components';

export const LinkWrapper = styled.div`
  a {
    color: #9ea0a1;
    font-size: 18px;
    line-height: 44px;
    text-transform: capitalize;
    border-bottom: 2px solid transparent;
    display: inline-block;
    padding: 2px 0px;
    cursor: pointer;
    position: relative;

  }

  [aria-current="page"] {
    color: ${props => props.theme.colors.primary};
    border-bottom-color: ${props => props.theme.colors.primary};
  }
`;

export const Unread = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  top: 14px;
  right: -6px;
  background-color: ${props => props.theme.colors.primary};
`;
